import { useState, useEffect } from 'react';
import api from '../utils/api';
import { useAuth } from '../components/context/AuthContext';
import { useSocket } from '../components/context/SocketProvider';

export const useSupportNotifications = () => {
    const [unreadSupportCount, setUnreadSupportCount] = useState(0);
    const { user, loading } = useAuth();
    const socket = useSocket();

    const fetchCount = async () => {
        if (user) {
            try {
                const { data } = await api.get('/support/unread-count');
                setUnreadSupportCount(data.count);
            } catch (err) {
                console.error("Error fetching support count", err);
            }
        }
    };

    useEffect(() => {
        // ⭐ FIX: wait for the real session, not just the cached profile.
        // AuthContext hydrates `user` IMMEDIATELY from a cached localStorage
        // profile on page load, before the real __session cookie exists —
        // the login round trip is still in flight. Firing this fetch against
        // that cached-but-not-yet-authenticated state got a 403 every time
        // (harmless — it retries once the real session settles and `user`
        // updates again — but noisy). `loading` only goes false once auth
        // has genuinely resolved.
        if (loading) return;
        fetchCount();

        // 1. Define the handler so we have a specific reference to it
        const handleTicketUpdate = () => {
            fetchCount();
        };

        if (socket) {
            // 2. Attach the specific handler
            socket.on('support_ticket_updated', handleTicketUpdate);
        }

        return () => {
            if (socket) {
                // 3. Precision strike: only remove this exact listener, not all of them
                socket.off('support_ticket_updated', handleTicketUpdate);
            }
        };
    }, [user, loading, socket]);

    return { unreadSupportCount, refreshCount: fetchCount };
};